export enum Permissions {
  AccessAdminDashboard = 0,
  AccessAdminSignUpWizard = 1,
  AccessEligibleEmployeeSignupWizard = 2,
  AccessEligibleEmployeeDashboard = 3,
  AccessNonEligibleEmployeeSignupWizard = 4,
  AccessNonEligibleEmployeeDashboard = 5,
  AccessDocReviewDashboard = 6,
  AccessCsiDashboard = 7,
  AccessScheduledJobs = 8,
  AccessInternalUsers = 9,
  AccessIchraDecisionTools = 10,
  AccessMigration = 11,
  AccessReports = 12,
  AccessEmailTemplates = 13,
}
